import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import 'react-datepicker/dist/react-datepicker.css'
import style from './DateTimePicker.module.scss'
import PickerField from './Field'

const DateTimePicker = ({ inline, ...props }) => (
	<div className={classNames(style.root, { 'date-picker-interval': props.interval, 'inline': inline })}>
		<PickerField {...props} className={props.interval ? style.interval : ''}/>
	</div>
)


DateTimePicker.propTypes = {
	field: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	noForm: PropTypes.bool,
	interval: PropTypes.bool,
	picker: PropTypes.oneOf(['date', 'time']),
	label: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			from: PropTypes.string,
			to: PropTypes.string
		})
	]),
	placeholder: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			from: PropTypes.string,
			to: PropTypes.string
		})
	]),
	inline: PropTypes.bool,
	id: PropTypes.string,
	addDateToTime: PropTypes.bool, // Add date '1899-12-30' (default date for all time values in DB) to time
	disablePast: PropTypes.bool
}

DateTimePicker.defaultProps = {
	addDateToTime: true
}

export default DateTimePicker
